var _defs, _rect, _g, _path, _path2, _path3, _path4, _path5, _line, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBridge = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 3333 640",
  width: 3333.333,
  height: 640,
  preserveAspectRatio: "xMidYBottom slice",
  fill: "none",
  ref: ref
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "horizon-ambient-glow",
  cx: "50%",
  cy: "70%",
  r: "50%",
  fx: "50%",
  fy: "70%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00DFD8",
  stopOpacity: 0.18
}), /*#__PURE__*/React.createElement("stop", {
  offset: "35%",
  stopColor: "#0070F3",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "70%",
  stopColor: "#7928CA",
  stopOpacity: 0.04
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0070F3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cyber-stream-primary",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#0070F3",
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: "20%",
  stopColor: "#00DFD8",
  stopOpacity: 0.75
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#0070F3",
  stopOpacity: 0.95
}), /*#__PURE__*/React.createElement("stop", {
  offset: "80%",
  stopColor: "#7928CA",
  stopOpacity: 0.65
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0070F3",
  stopOpacity: 0.05
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "cyber-stream-secondary",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#7928CA",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "25%",
  stopColor: "#7928CA",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#00DFD8",
  stopOpacity: 0.65
}), /*#__PURE__*/React.createElement("stop", {
  offset: "75%",
  stopColor: "#0070F3",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00DFD8",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "wave-fill-deep",
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#0070F3",
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#00DFD8",
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#000000",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grid-fade",
  x1: "0%",
  y1: "0%",
  x2: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00DFD8",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "30%",
  stopColor: "#0070F3",
  stopOpacity: 0.22
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0070F3",
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("filter", {
  id: "neon-glow",
  x: "-20%",
  y: "-20%",
  width: "140%",
  height: "140%"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4,
  result: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic",
  in2: "blur"
})))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 160,
  width: 3333,
  height: 480,
  fill: "url(#horizon-ambient-glow)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "url(#grid-fade)",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: -400,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 50,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 480,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 880,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 1220,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 1480,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 1853,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 2113,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 2453,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 2853,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 3283,
  y2: 640
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 420,
  x2: 3733,
  y2: 640
}), /*#__PURE__*/React.createElement("path", {
  d: "M 0,442 Q 1666,424 3333,442",
  opacity: 0.35
}), /*#__PURE__*/React.createElement("path", {
  d: "M 0,475 Q 1666,450 3333,475",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M 0,520 Q 1666,485 3333,520",
  opacity: 0.65
}), /*#__PURE__*/React.createElement("path", {
  d: "M 0,575 Q 1666,532 3333,575",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M 0,638 Q 1666,588 3333,638",
  opacity: 0.95
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M 0,460 C 550,380 1100,530 1666,440 C 2233,350 2780,510 3333,430 L 3333,640 L 0,640 Z",
  fill: "url(#wave-fill-deep)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M 0,510 C 450,570 1000,430 1566,500 C 2133,570 2680,420 3333,490",
  stroke: "url(#cyber-stream-secondary)",
  strokeWidth: 1.8,
  strokeDasharray: "10 8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M 0,460 C 550,380 1100,530 1666,440 C 2233,350 2780,510 3333,430",
  stroke: "url(#cyber-stream-primary)",
  strokeWidth: 3,
  filter: "url(#neon-glow)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M 0,460 C 550,380 1100,530 1666,440 C 2233,350 2780,510 3333,430",
  stroke: "#00DFD8",
  strokeWidth: 1.5,
  strokeOpacity: 0.9
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M 0,420 C 600,480 1200,370 1750,450 C 2300,520 2850,380 3333,440",
  stroke: "url(#cyber-stream-primary)",
  strokeWidth: 1.6
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  y1: 420,
  x2: 3333,
  y2: 420,
  stroke: "url(#cyber-stream-primary)",
  strokeWidth: 1.2,
  strokeOpacity: 0.7
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 550,
  cy: 380,
  r: 4.5,
  fill: "#00DFD8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 550,
  cy: 380,
  r: 10,
  stroke: "#00DFD8",
  strokeOpacity: 0.4
}), /*#__PURE__*/React.createElement("line", {
  x1: 550,
  y1: 380,
  x2: 550,
  y2: 640,
  stroke: "#00DFD8",
  strokeWidth: 0.8,
  strokeDasharray: "4 4",
  strokeOpacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1100,
  cy: 530,
  r: 3.5,
  fill: "#0070F3"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1100,
  cy: 530,
  r: 8,
  stroke: "#0070F3",
  strokeOpacity: 0.35
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1666,
  cy: 440,
  r: 6,
  fill: "#00DFD8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1666,
  cy: 440,
  r: 14,
  stroke: "#00DFD8",
  strokeWidth: 1.2,
  strokeOpacity: 0.6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1666,
  cy: 440,
  r: 24,
  stroke: "#0070F3",
  strokeWidth: 0.8,
  strokeDasharray: "6 6",
  strokeOpacity: 0.35
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 440,
  x2: 1666,
  y2: 640,
  stroke: "#00DFD8",
  strokeDasharray: "4 4",
  strokeOpacity: 0.45
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2233,
  cy: 350,
  r: 5,
  fill: "#7928CA"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2233,
  cy: 350,
  r: 12,
  stroke: "#7928CA",
  strokeOpacity: 0.45
}), /*#__PURE__*/React.createElement("line", {
  x1: 2233,
  y1: 350,
  x2: 2233,
  y2: 640,
  stroke: "#7928CA",
  strokeWidth: 0.8,
  strokeDasharray: "4 4",
  strokeOpacity: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2780,
  cy: 510,
  r: 3.5,
  fill: "#00DFD8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2780,
  cy: 510,
  r: 8,
  stroke: "#00DFD8",
  strokeOpacity: 0.35
}), /*#__PURE__*/React.createElement("line", {
  x1: 550,
  y1: 380,
  x2: 1100,
  y2: 530,
  stroke: "#00DFD8",
  strokeWidth: 0.7,
  strokeDasharray: "3 5",
  strokeOpacity: 0.25
}), /*#__PURE__*/React.createElement("line", {
  x1: 1100,
  y1: 530,
  x2: 1666,
  y2: 440,
  stroke: "#0070F3",
  strokeWidth: 0.7,
  strokeDasharray: "3 5",
  strokeOpacity: 0.3
}), /*#__PURE__*/React.createElement("line", {
  x1: 1666,
  y1: 440,
  x2: 2233,
  y2: 350,
  stroke: "#7928CA",
  strokeWidth: 0.7,
  strokeDasharray: "3 5",
  strokeOpacity: 0.3
}), /*#__PURE__*/React.createElement("line", {
  x1: 2233,
  y1: 350,
  x2: 2780,
  y2: 510,
  stroke: "#00DFD8",
  strokeWidth: 0.7,
  strokeDasharray: "3 5",
  strokeOpacity: 0.25
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBridge);
export default ForwardRef;